import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase } from '../../../../form-atyl-base'



@Component({
	selector: 'atyl-form-input-email',
	templateUrl: './form-input-email.component.html',
	styleUrls: ['./form-input-email.component.scss']
})
export class FormInputEmailComponent implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>()
	label: string
	errorString: string

	constructor(
		private readonly inputLabelPipe: InputLabelPipe
	) {

	}

	ngOnInit(): void {
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}
	customBehaviourHandler(customBehaviour: any) {
		this.inputTyped.emit(customBehaviour)
	}
	replaceValue(newValue: any) {
		this.group.get(String(this.forminput.ID)).setValue(newValue.value)
	}
}
